import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  line: '',
  fixedStamp: '',
  fixedStampCurrency: '',
  proportionalStamp: '',
  municipalityTax: '',
  taxOnCommission: '',
  reinsuranceTax: '',
  effectiveFrom: '',
  effectiveTo: '',
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      line: {
        name: 'line',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: !isEmpty(initialValues.line) ? [initialValues.line] : [],
        disabled: false,
        required: true,
        selectOptions: {},
      },
      fixedStamp: {
        name: 'fixedStamp',
        title: 'Fixed Stamp',
        placeholder: 'FIxed Stamp',
        type: FormFieldType.number,
        value: initialValues.fixedStamp,
        required: true,
        disabled: false,
        maxDecimalPrecision: 3,
      },
      fixedStampCurrency: {
        name: 'fixedStampCurrency',
        title: 'Fixed Stamp Currency',
        type: FormFieldType.select,
        placeholder: 'Fixed Stamp Currency',
        value: !isEmpty(initialValues.fixedStampCurrency)
          ? [initialValues.fixedStampCurrency]
          : [],
        disabled: false,
        required: true,
        injectGlobalLov: {
          type: 'currency',
          value: 'Id',
          display: 'Title',
        },
      },
      proportionalStamp: {
        name: 'proportionalStamp',
        title: 'Proportional Stamp',
        placeholder: 'Proportional Stamp',
        type: FormFieldType.percentage,
        value: initialValues.proportionalStamp,
        required: true,
      },
      municipalityTax: {
        name: 'municipalityTax',
        title: 'Municipality Tax',
        placeholder: 'Municipality Tax',
        type: FormFieldType.percentage,
        value: initialValues.municipalityTax,
        required: true,
      },
      taxOnCommission: {
        name: 'taxOnCommission',
        title: 'Tax On Commission',
        placeholder: 'Tax On Commission',
        type: FormFieldType.percentage,
        value: initialValues.taxOnCommission,
        required: true,
      },
      reinsuranceTax: {
        name: 'reinsuranceTax',
        title: 'Reinsurance Tax',
        placeholder: 'Reinsurance Tax',
        type: FormFieldType.percentage,
        value: initialValues.reinsuranceTax,
        required: true,
      },
      effectiveFrom: {
        name: 'effectiveFrom',
        title: 'Effective From',
        placeholder: 'Effective From',
        type: FormFieldType.date,
        value: initialValues.effectiveFrom,
        required: true,
        minDate: new Date(),
      },
      effectiveTo: {
        name: 'effectiveTo',
        title: 'Effective To',
        placeholder: 'Effective To',
        type: FormFieldType.date,
        value: initialValues.effectiveTo,
        disabled: true,
      },
    },
  },
];
